var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C4.8645 3 1.5 6.3645 1.5 10.5C1.49903 11.6575 1.76898 12.7992 2.28825 13.8337C2.41575 14.0887 2.67525 14.25 2.9595 14.25H15.0398C15.324 14.25 15.5843 14.0887 15.7118 13.8337C16.231 12.7992 16.501 11.6575 16.5 10.5C16.5 6.3645 13.1355 3 9 3ZM14.5575 12.75H3.4425C3.14943 12.0361 2.99909 11.2717 3 10.5C3 7.19175 5.69175 4.5 9 4.5C12.3083 4.5 15 7.19175 15 10.5C15.0009 11.2717 14.8506 12.0361 14.5575 12.75Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20427 9.70421C8.04473 9.80855 7.91369 9.95098 7.823 10.1187C7.73231 10.2863 7.68481 10.474 7.68481 10.6646C7.68481 10.8552 7.73231 11.0428 7.823 11.2105C7.91369 11.3782 8.04473 11.5206 8.20427 11.625C8.33034 11.7079 8.47153 11.7652 8.61976 11.7935C8.76798 11.8218 8.92034 11.8206 9.0681 11.7899C9.21586 11.7593 9.35613 11.6998 9.48086 11.6149C9.6056 11.5299 9.71236 11.4212 9.79502 11.295L12.7665 6.76646C12.7689 6.7625 12.7702 6.75796 12.7702 6.75334C12.7702 6.74871 12.7689 6.74418 12.7665 6.74021C12.763 6.73481 12.7575 6.73099 12.7512 6.72959C12.7449 6.72819 12.7383 6.72931 12.7328 6.73271L8.20427 9.70421Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.429eff976d3d763572fc3f43f17af87e.svg";
export { ForwardRef as ReactComponent };